var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.viewmode)?_c('div',[(!_vm.$parent.form_getvisible(_vm.names))?_c('span',{staticClass:"editbn",on:{"click":function($event){return _vm.$parent.form_visible(_vm.names)}}}):_c('span',{staticClass:"okbn",on:{"click":_vm.$parent.form_change}},[_vm._v("✓ OK")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }